/**
 * Utilities for safely revoking object URLs to prevent memory leaks.
 * Use these whenever URL.createObjectURL() is used.
 */

/**
 * Revokes a single blob URL if it is a valid object URL.
 * Safe to call multiple times or with non-blob URLs (no-op).
 */
export function revokeBlobUrl(url: string | undefined | null): void {
  if (url?.startsWith?.('blob:')) {
    try {
      URL.revokeObjectURL(url);
    } catch {
      // Already revoked or invalid - ignore
    }
  }
}

/**
 * Revokes all blob URLs from an array of items that have a url property.
 * Use when cleaning up preview images, videos, or media state.
 */
export function revokeBlobUrls(items: Array<{ url?: string }>): void {
  items.forEach((item) => revokeBlobUrl(item?.url));
}
